// extracted by mini-css-extract-plugin
module.exports = {"banner":"Banner--banner--2WkmS","branding":"Banner--branding--2cmM1","wordmark":"Banner--wordmark--1UwIq","description":"Banner--description--GV67m","trial":"Banner--trial--1FJCQ"};